export default {"src":"/_next/static/media/banner2.758344db.svg","height":140,"width":1920,"blurWidth":0,"blurHeight":0};